// The Forgot password page (views/authentication/forgot-password.js): what it says after "Send me a link". The same
// words whether or not the address has an account, so the page does not tell who has one.
export const LOGIN_PATH = '/authentication/login2'

// data: password/sendtoken's reply (null: the server could not be reached) -> { sent, text }
export function forgotPasswordReply(data, email) {
	if (!data) {
		return { sent: false, text: 'Could not reach the server. Please try again.' }
	}
	const code = Number(data.code)
	if (code === 201 || code === 404 || (code === 400 && notAnAccount(data))) {
		return {
			sent: true,
			text: 'If ' + email + ' is the email address of a Mobiliis account, we have sent it a link to choose a new password. '
				+ 'Please check your inbox (and the spam folder). The link works for 12 hours.',
		}
	}
	return { sent: false, text: 'Please check the email address and try again.' }
}

// password/sendtoken's 400 for an address with no account (Laravel's "exists" rule), not for one that is not an address
function notAnAccount(data) {
	const errors = data && data.message && data.message.errors && data.message.errors.email
	return Array.isArray(errors) && errors.some((text) => /invalid|selected/i.test(String(text)))
}
